import { useEffect, useRef, useState } from 'react';

export const useHeaderVisibility = () => {
  const [showHeader, setShowHeader] = useState(true);
  const lastScrollY = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;

          // Anti-bounce for Safari / generic checks
          if (currentScrollY <= 0) {
            setShowHeader(true);
            lastScrollY.current = 0;
            ticking.current = false;
            return;
          }

          if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
            setShowHeader((prev) => (prev ? false : prev));
          } else if (currentScrollY < lastScrollY.current) {
            setShowHeader((prev) => (!prev ? true : prev));
          }

          lastScrollY.current = currentScrollY;
          ticking.current = false;
        });
        ticking.current = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return showHeader;
};
